import React from 'react'
import {
  StyledP,
  ErrorText,
  Wrapper,
} from 'modules/Students/Partials/StudentsBulkUpload/Partials/ErrorInfoTable/Style/style'
import { StyledTable } from 'components/TableStyles/TableStyles'

const ErrorCorporateTable = ({ data }) => {
  const columns = [
    {
      title: 'Corporate Name',
      dataIndex: 'corporateName',
      render: (text, item) => (
        <StyledP>
          {item['Company Name']} 
        </StyledP>
      ),
    },
   
    {
      title: 'Error',
      dataIndex: 'error',
      render: (text, item) => <ErrorText>{item?.error?.toString()}</ErrorText>,
    },
  ]
  return (
    <Wrapper>
      <StyledTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{ position: ['none'] }}
      />
    </Wrapper>
  )
}

export default ErrorCorporateTable
